import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import ContactFormSection from './sections/ContactFormSection';
import ContactInfoSection from './sections/ContactInfoSection';
import './ContactPage.scss';

const ContactPage = () => {
    const { t } = useTranslation();

    return (
        <div className="contact-page">
            <Helmet>
                <title>{t('seo_contact_title')}</title>
                <meta name="description" content={t('seo_contact_description')} />
                <meta property="og:title" content={t('seo_contact_title')} />
                <meta property="og:description" content={t('seo_contact_description')} />
                <meta property="og:type" content="website" />
            </Helmet>
            <Header />
            <ContactFormSection />
            <ContactInfoSection />
            <Footer />
        </div>
    );
};

export default ContactPage;
